"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DefaultOption = void 0;
var _BaseOption = require("./BaseOption");
var _jsxRuntime = require("react/jsx-runtime");
const DefaultOption = (param)=>{
    let { selected, label, onClick, onDelete, LabelProps, OptionProps } = param;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_BaseOption.BaseOption, {
        variant: "rounded",
        label: label,
        selected: selected,
        LabelProps: LabelProps,
        height: OptionProps === null || OptionProps === void 0 ? void 0 : OptionProps.height,
        onClick: onClick,
        onDelete: onDelete
    });
};
exports.DefaultOption = DefaultOption;
